export function isVoterRewards(item) {
    return item?.type === "VoterRewards";
}
export function isVoterRewardsBase(item) {
    return item?.type === "VoterRewardsBase";
}
//# sourceMappingURL=voter-rewards.js.map